import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "breadcrumb float-sm-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Home")
], -1)
const _hoisted_8 = { class: "breadcrumb-item active" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "container-fluid" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { class: "card-tools" }
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "card-body row" }
const _hoisted_19 = { class: "form-group col-12 col-md-6" }
const _hoisted_20 = { for: "idCustomer" }
const _hoisted_21 = { class: "form-group col-12 col-md-6" }
const _hoisted_22 = { for: "name" }
const _hoisted_23 = { class: "form-group col-12 col-md-6" }
const _hoisted_24 = { for: "email" }
const _hoisted_25 = { class: "form-group col-12 col-md-6" }
const _hoisted_26 = { for: "username" }
const _hoisted_27 = { class: "form-group col-12 col-md-6" }
const _hoisted_28 = { for: "type" }
const _hoisted_29 = { class: "form-group col-12 col-md-6" }
const _hoisted_30 = { for: "enabled" }
const _hoisted_31 = { class: "card-footer text-center" }
const _hoisted_32 = { class: "btn-group" }
const _hoisted_33 = {
  key: 0,
  class: "modal fade show",
  style: {"display":"block","padding-right":"15px"}
}
const _hoisted_34 = { class: "modal-dialog modal-lg" }
const _hoisted_35 = { class: "modal-content" }
const _hoisted_36 = { class: "modal-header" }
const _hoisted_37 = { class: "modal-title" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "modal-body" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "form-group col-12 col-xs-12" }
const _hoisted_43 = { for: "password" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ", -1)
const _hoisted_45 = { class: "input-group input-group-sm" }
const _hoisted_46 = ["type"]
const _hoisted_47 = { class: "input-group-append" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "form-group col-12 col-xs-12" }
const _hoisted_51 = { for: "confirmPassword" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ", -1)
const _hoisted_53 = { class: "input-group input-group-sm" }
const _hoisted_54 = ["type"]
const _hoisted_55 = { class: "input-group-append" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { class: "modal-footer justify-content-between" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("labels.page.users")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t("labels.page.users")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.$t("labels.page.users")) + " | " + _toDisplayString(_ctx.id), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tool",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.goBack())),
                title: _ctx.$t('labels.buttons.goBack')
              }, _hoisted_17, 8, _hoisted_15)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
              [_vShow, _ctx.errorMessage != '']
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("labels.entity.customer")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.row.customer ? _ctx.row.customer.name : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("labels.entity.name")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.row.name), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("labels.entity.email")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.row.email), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("labels.entity.username")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.row.username), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("labels.entity.type")) + ":    ", 1),
              _createElementVNode("span", {
                class: _normalizeClass(["badge", {
            'bg-success': _ctx.row.type === 1,
            'bg-warning': _ctx.row.type === 2
          }])
              }, _toDisplayString(_ctx.row.type === 1 ? _ctx.$t('labels.user.type.admin') : _ctx.$t('labels.user.type.customer')), 3)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("labels.entity.active")) + ":    ", 1),
              _createElementVNode("span", {
                class: _normalizeClass(["badge", {
            'bg-success': _ctx.row.enabled,
            'bg-danger': !_ctx.row.enabled
          }])
              }, _toDisplayString(_ctx.row.enabled ? _ctx.$t("labels.yes") : _ctx.$t("labels.no")), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", {
                type: "button",
                id: "cancelButton",
                class: "btn btn-sm btn-info",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.goBack()))
              }, _toDisplayString(_ctx.$t("labels.buttons.goBack")), 1),
              (_ctx.hasPermission('edit'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    id: "editButton",
                    class: "btn btn-sm btn-warning",
                    onClick: _cache[2] || (_cache[2] = $event => (_ctx.edit()))
                  }, _toDisplayString(_ctx.$t("labels.buttons.edit")), 1))
                : _createCommentVNode("", true),
              (_ctx.hasPermission('edit'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    id: "editButton",
                    class: "btn btn-sm btn-danger",
                    onClick: _cache[3] || (_cache[3] = $event => (_ctx.newPassword()))
                  }, _toDisplayString(_ctx.$t("labels.buttons.changePassword")), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (_ctx.showModalChangePassword)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("h4", _hoisted_37, _toDisplayString(_ctx.$t("labels.page.changePassword")), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "close",
                      "aria-label": "Fechar",
                      onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                    }, _hoisted_39)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("label", _hoisted_43, [
                          _createTextVNode(_toDisplayString(_ctx.$t("labels.entity.password")) + " ", 1),
                          _hoisted_44
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _withDirectives(_createElementVNode("input", {
                            id: "password",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.rowPassword.password) = $event)),
                            type: _ctx.showPasswordField ? 'text' : 'password',
                            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.password }]),
                            maxlength: "200"
                          }, null, 10, _hoisted_46), [
                            [_vModelDynamic, _ctx.rowPassword.password]
                          ]),
                          _createElementVNode("span", _hoisted_47, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-info btn-flat",
                              onClick: _cache[6] || (_cache[6] = $event => (_ctx.togglePasswordVisibility()))
                            }, _hoisted_49)
                          ])
                        ]),
                        _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.password), 513), [
                          [_vShow, _ctx.errors.password != null]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("label", _hoisted_51, [
                          _createTextVNode(_toDisplayString(_ctx.$t("labels.entity.confirmPassword")) + " ", 1),
                          _hoisted_52
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _withDirectives(_createElementVNode("input", {
                            id: "confirmPassword",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.rowPassword.confirmPassword) = $event)),
                            type: _ctx.showConfirmPasswordField ? 'text' : 'password',
                            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.confirmPassword }]),
                            maxlength: "200"
                          }, null, 10, _hoisted_54), [
                            [_vModelDynamic, _ctx.rowPassword.confirmPassword]
                          ]),
                          _createElementVNode("span", _hoisted_55, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-info btn-flat",
                              onClick: _cache[8] || (_cache[8] = $event => (_ctx.toggleConfirmPasswordVisibility()))
                            }, _hoisted_57)
                          ])
                        ]),
                        _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.confirmPassword), 513), [
                          [_vShow, _ctx.errors.confirmPassword != null]
                        ])
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
                      [_vShow, _ctx.errorMessage != '']
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-default",
                      onClick: _cache[9] || (_cache[9] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                    }, _toDisplayString(_ctx.$t("labels.buttons.goBack")), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-primary",
                      onClick: _cache[10] || (_cache[10] = $event => (_ctx.savePassword(_ctx.showPassword)))
                    }, _toDisplayString(_ctx.$t("labels.buttons.save")), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}